<template>
    <div>
        <router-view />
        <logout />
    </div>
</template>
<script>
import Logout from '../common/modals/logout/logout.vue';

export default {
    name: 'root-layout',
    components: { Logout }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/root-layout.vue